export default __webpack_public_path__ + "static/CodeLoungeLogo-white-ff19c192e8a85cb847f6105ecd686bba.png";